import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/trip/page.jsx");
